export default {
  //----
  credentialsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '24px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'right',
    flex: 1,
    marginTop: 16,
    gap: 16,
  },
  buttonPassword: {
    display: 'flex',
    justifyContent: 'left',
    flex: 1,
    marginTop: 16,
    gap: 16,
  },
  port: {
    maxWidth: 100,
  },
  s3User: {
    maxWidth: 150,
  },
  inputContainer: {
    flex: 1,
    width: '80%',
    maxWidth: '80%',
    padding: 8,
    boxSizing: 'border-box',
  },
  header: {
    marginBottom: 8,
    fontWeight: 'bold',
  },
  confTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#3d3d3d',
  },
  validateSFTPWithoutErrors: {
    display: 'flex',
    gap: 16,
    marginTop: 16,
    marginBottom: 16,
    color: 'green',
  },
  validateSFTPWithErrors: {
    display: 'flex',
    gap: 16,
    marginTop: 16,
    marginBottom: 16,
    color: 'red',
  },
};
